import * as React from 'react';
import { Link } from 'react-router-dom';

import ActionButton from '../containers/ActionButton';
import EmailField from '../containers/EmailField';
import Footer from './Footer';
import Notification from '../containers/Notification';

import logo from '../images/img-built-logo.svg';
import * as styles from './LoginSso.module.scss';
import l10n from '@built/i18n';

/**
 * Renders the SSO-specific login view; this will collect a user's
 * email address and look up whether they should be redirected
 * to an SSO endpoint. If we receive a redirect URL, then we
 * issue a browser redirect to initiate SSO
 */
export default function LoginSso(props: LoginSsoProps) {
  const builtLogo = logo;
  return (
    <div className={styles.componentContainer}>
      <div className={styles.loginFormContainer}>
        <form className={styles.loginForm} onSubmit={props.onSubmit}>
          <Link
            to="/"
            className={styles.backLink}
            onClick={props.onBackButtonClick}
          >
            &larr;{' '}
            {l10n.t('LoginSso:Link.backStandard', 'Back to Standard Login')}
          </Link>
          <img className={styles.logo} src={builtLogo} />

          {props.showSsoError && (
            <Notification
              type="danger"
              title={l10n.t(
                'LoginSso:Notification.notConfigured.title',
                'Single sign-on error'
              )}
              className={styles.errorMessage}
            >
              <p>
                {l10n.t(
                  'LoginSso:Notification.notConfigured.message',
                  `It doesn't look like your account has been configured to log in with single sign-on. ` +
                    `Please contact your IT administrator for more information.`
                )}
              </p>
            </Notification>
          )}

          <EmailField
            className={styles.emailField}
            autoFocus={true}
            disabled={props.busy}
            onChange={props.onEmailAddressChange}
            name="email"
            showError={props.showEmailError}
          />

          <ActionButton
            className={styles.actionButton}
            label={l10n.t('LoginSso:Button.continue', 'Continue')}
            loading={props.busy}
            type="submit"
          />

          <Footer className={styles.copyright} basic={true} />
        </form>
      </div>
    </div>
  );
}

export interface LoginSsoProps {
  /** Whether a request is in flight */
  busy: boolean;

  /** Should we show the invalid email address error? */
  showEmailError: boolean;

  /** Should we show the SSO error? */
  showSsoError: boolean;

  /** Back button handler */
  onBackButtonClick(event: React.SyntheticEvent<HTMLElement>): void;

  /** EmailField change handler */
  onEmailAddressChange(email: string, valid: boolean): void;

  /** Submit handler */
  onSubmit(event: React.SyntheticEvent<HTMLElement>): void;
}



// WEBPACK FOOTER //
// ./src/components/LoginSso.tsx